var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.52449V15.0003C18.3334 15.4424 18.1578 15.8663 17.8453 16.1788C17.5327 16.4914 17.1088 16.667 16.6667 16.667H5.83341C5.39139 16.667 4.96746 16.4914 4.6549 16.1788C4.34234 15.8663 4.16675 15.4424 4.16675 15.0003V13.7503M18.3334 9.52449V8.33366C18.3334 7.89163 18.1578 7.46771 17.8453 7.15515C17.5327 6.84259 17.1088 6.66699 16.6667 6.66699H15.8334M18.3334 9.52449H15.8334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 6.66667V12.0833C15.8334 12.5254 15.6578 12.9493 15.3453 13.2618C15.0327 13.5744 14.6088 13.75 14.1667 13.75H3.33341C2.89139 13.75 2.46746 13.5744 2.1549 13.2618C1.84234 12.9493 1.66675 12.5254 1.66675 12.0833V5.41667C1.66675 4.97464 1.84234 4.55072 2.1549 4.23816C2.46746 3.92559 2.89139 3.75 3.33341 3.75H14.1667C14.6088 3.75 15.0327 3.92559 15.3453 4.23816C15.6578 4.55072 15.8334 4.97464 15.8334 5.41667V6.66667ZM15.8334 6.66667H4.58341",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimW);
export default __webpack_public_path__ + "static/media/claimW.0c11004ff4455f2620e5d0b02b137ca4.svg";
export { ForwardRef as ReactComponent };